<template>
  <div class="col-12 list-container mb-4">
    <div :class="['w-100', 'd-flex', 'justify-content-center', 'icon-list', {'icon-list-collapsed': isListCollapsed}]">
      <slot name="list" />
    </div>
    <div
      class="d-flex justify-content-center align-items-center toggle-container"
      :class="{'mt-3': isListCollapsed}"
    >
      <b-button
        size="sm"
        variant="text"
        class="p-0 position-relative"
        @click="toggleIconsList"
      >
        <span v-if="isListCollapsed" class="d-flex align-items-center">
          <font-awesome-icon class="position-absolute" :icon="'sort-up'" size="2x" />
          <span class="toggle-text">Hide key</span>
        </span>
        <span v-else class="d-flex align-items-center">
          <font-awesome-icon class="mr-2 position-absolute" :icon="'sort-down'" size="2x" />
          <span class="toggle-text">Show key</span>
        </span>
      </b-button>
    </div>
  </div>
</template>

<script>

export default {
  "name": 'ListAccordion',
  "data": function () {
    return {
      isListCollapsed: false,
    }
  },
  "methods": {
    toggleIconsList: function () {
      this.isListCollapsed = !this.isListCollapsed;
    }
  }
}
</script>
<style scoped lang="scss">
.list-container {

  .icon-list {
    height: 0;
    display: flex;
    overflow: hidden;
    
    @media only screen and (max-device-width : 375px) {
      font-size: 12px;
    }
  }

  .icon-list-collapsed {
    height: auto;
    overflow: auto;
  }
}

.toggle-text {
  margin-left: 15px;
}

.toggle-container {
  &:before,
  &:after {
    content: '\200C';
    height: 2px;
    width: 17%;
    background-color: $border-color;
  }

  &:after {
    margin-left: 25px;
  }

  &:before {
    margin-right: 25px;
  }

  .fa-sort-down {
    left: -5px;
    top: -8px;
  }

  .fa-sort-up{
    left: -5px;
    top: 2px;
  }
}
</style>
